export default "__VITE_ASSET__B7dEl47N__"